import { render } from "./TalkingPoints.vue?vue&type=template&id=3cfe28e6&scoped=true"
import script from "./TalkingPoints.vue?vue&type=script&lang=js"
export * from "./TalkingPoints.vue?vue&type=script&lang=js"

import "./TalkingPoints.vue?vue&type=style&index=0&id=3cfe28e6&scoped=true&lang=css"

import exportComponent from "C:\\code\\kascenskaforvt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cfe28e6"]])

export default __exports__